interface ConstDataType {
    captcha_site_key: string
    supabase_url: string
    supabase_anon_key: string
    discover_puzzle_row_height: number
    max_keypoints_count: number
}

export const ConstData: ConstDataType = {
    captcha_site_key: "fd882d62-a2fe-40ce-81fc-1d462f62c806",
    supabase_url: "https://rjcimftlmzcpokybxtet.supabase.co",
    supabase_anon_key: "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6InJqY2ltZnRsbXpjcG9reWJ4dGV0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NTY5NDkwOTksImV4cCI6MjA3MjUyNTA5OX0.oeXp7son5CCkVNo8BYNbGh1vpeoq4VZdGTr1d_QbEDQ",
    discover_puzzle_row_height: 120,
    max_keypoints_count: 4,
};

export const PuzzleThemes = [
    'honkaku',
    'henkaku',
    'hardcore',
    'quirky',
    'suspense',
    'casual',
    'horror',
    'heartwarming',
] as const;

export type PuzzleThemeCode = typeof PuzzleThemes[number];
